export default "__VITE_ASSET__DgsMCZyq__"